import React from 'react'
import { connect } from 'react-redux'
import { Toast } from 'antd-mobile'
import { getShareStatistics } from '../../api/ShareStatistics'
import Lodding from '../../components/Lodding'
import leftIcon from '../../static/icons/leftIcon.png'
import './index.scss'

class ShareStatistics extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      statistics: null
    }
  }

  componentDidMount() {
    this.fetchStatistics()
  }

  // 返回上一页
  goBack = () => {
    this.props.history.goBack()
  }

  fetchStatistics = async () => {
    try {
      this.setState({ loading: true })
      const res = await getShareStatistics()
      if (res.code === 200) {
        this.setState({
          statistics: res.data
        })
      } else {
        Toast.fail(res.message || '获取统计数据失败', 2)
      }
    } catch (error) {
      Toast.fail('获取统计数据失败', 2)
      console.error(error)
    } finally {
      this.setState({ loading: false })
    }
  }

  formatAmount = (amount) => {
    if (amount === null || amount === undefined) return '0.00'
    return Number(amount).toLocaleString('zh-CN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  render() {
    const { statistics, loading } = this.state

    return (
      <div className="share-statistics-page">
        {/* 渐变头部 */}
        <div className="page-header">
          <div className="header-back" onClick={this.goBack}>
            <img src={leftIcon} alt="返回" />
          </div>
          <div className="header-title">分成统计</div>
        </div>

        <Lodding animating={loading} />

        {/* 内容区域 */}
        <div className="content-area">
          {/* 项目状态统计 */}
          <div className="statistics-section">
            <div className="section-title">
              <span className="title-bar"></span>
              项目状态
            </div>
            <div className="status-cards">
              <div className="status-card not-started">
                <div className="status-count">{statistics ? (statistics.notStartedCount || 0) : 0}</div>
                <div className="status-label">未开始</div>
              </div>
              <div className="status-card in-progress">
                <div className="status-count">{statistics ? (statistics.inProgressCount || 0) : 0}</div>
                <div className="status-label">进行中</div>
              </div>
              <div className="status-card finished">
                <div className="status-count">{statistics ? (statistics.finishedCount || 0) : 0}</div>
                <div className="status-label">已结束</div>
              </div>
            </div>
          </div>

          {/* 维保分成金额 */}
          <div className="statistics-section">
            <div className="section-title">
              <span className="title-bar"></span>
              维保分成
            </div>
            <div className="amount-list">
              <div className="amount-item">
                <div className="amount-label">本周</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.maintainWeekAmount)}</span>
                </div>
              </div>
              <div className="amount-item">
                <div className="amount-label">本月</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.maintainMonthAmount)}</span>
                </div>
              </div>
              <div className="amount-item">
                <div className="amount-label">本季度</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.maintainQuarterAmount)}</span>
                </div>
              </div>
              <div className="amount-item">
                <div className="amount-label">本年</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.maintainYearAmount)}</span>
                </div>
              </div>
            </div>
          </div>

          {/* 维修分成金额 */}
          <div className="statistics-section">
            <div className="section-title">
              <span className="title-bar"></span>
              维修分成
            </div>
            <div className="amount-list">
              <div className="amount-item">
                <div className="amount-label">本周</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.repairWeekAmount)}</span>
                </div>
              </div>
              <div className="amount-item">
                <div className="amount-label">本月</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.repairMonthAmount)}</span>
                </div>
              </div>
              <div className="amount-item">
                <div className="amount-label">本季度</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.repairQuarterAmount)}</span>
                </div>
              </div>
              <div className="amount-item">
                <div className="amount-label">本年</div>
                <div className="amount-value">
                  <span className="currency">¥</span>
                  <span className="number">{this.formatAmount(statistics?.repairYearAmount)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  () => ({}),
  {}
)(ShareStatistics)
